// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let _;
if (typeof window === 'undefined') {
    _ = require('lodash');
} else {
    _ = window._;
}

(function () {

    'use strict';

    /**
     * Extends an object with all properties consistent with Underscore.
     */
    _.extend = function (obj) {

        if (!_.isObject(obj)) {

            return obj;
        }

        for (let temp, keys, i = 1, l = arguments.length; i < l; i++) {

            temp = arguments[i];
            keys = _.keysIn(temp);

            for (let key, j = 0, m = keys.length; j < m; j++) {

                key = keys[j];
                obj[key] = temp[key];
            }
        }

        return obj;
    };

    _.extendOwn = _.assign;

    const unescapeHtml = _.unescape;

    // NOTE we have extra unescaping that we may need to perform
    _.unescape = function (string) {
        return unescapeHtml(string).replace(/&#x27;/, `'`);
    };

}());
